<template>
    <div>

    </div>
</template>

<script>
    export default {
        name: "BoXueJia"
    }
</script>

<style scoped>

</style>